import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import { AddressEdit } from 'vant';

import 'babel-polyfill'
import Vant from 'vant'
import 'vant/lib/index.css'
import vueAwesomeSwiper from 'vue-awesome-swiper'
import 'vue-awesome-swiper/node_modules/swiper/dist/css/swiper.css'
Vue.use(vueAwesomeSwiper)
Vue.use(Vant)
Vue.use(AddressEdit);
Vue.use(VueClipboard)
import './components/common'

/* 全局css */
//import './styles/resetVantUI.scss'
// import 'normalize.css/normalize.css'
//import '@/styles/index.scss'

import '@/utils/permission'
import { enums } from '@/utils/enums'
Vue.prototype.$enums = enums()

import vConsole from 'vconsole'

//测试环境开启调试
//Vue.prototype.$vConsole = new vConsole()


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
/**
 * 定义空的vue实例，作为 eventbus实现非父子组件之间的通信(vue2.x中去掉了broadcast)
 */
var eventBus = new Vue({});
export default eventBus;



// WEBPACK FOOTER //
// ./src/main.js